import { Form } from "react-bootstrap";
import { UseFormRegisterReturn } from "react-hook-form";
import RequiredStar from "../RequiredStar";

interface FormGroupNumberProps {
  label: string;
  required?: boolean;
  register: UseFormRegisterReturn;
  allowDecimal?: boolean;
  readOnly?: boolean;
  backgroundColor?: string;
  className?: string;
  maxLength?: number;
}

export default function FormGroupNumber({
  label,
  required = false,
  register,
  allowDecimal = true,
  readOnly = false,
  backgroundColor,
  className = "",
  maxLength,
}: FormGroupNumberProps) {
  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    if (maxLength && input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  };

  return (
    <Form.Group className="mb-2">
      <Form.Label>
        {label} {required && <RequiredStar />}
      </Form.Label>
      <Form.Control
        type="number"
        {...register}
        onInput={handleInput}
        onKeyDown={
          !allowDecimal
            ? (e) => {
                if (e.key === ".") {
                  e.preventDefault();
                }
              }
            : undefined
        }
        readOnly={readOnly}
        className={`number-control-no-spinner${className ? ` ${className}` : ""}`}
        style={backgroundColor ? { backgroundColor } : undefined}
        required={required}
      />
    </Form.Group>
  );
}
